import { Link } from "react-router-dom";
import { JOYSPOT_QUIZ_URL } from "@/lib/constants";

const A = "/brand";
const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-[#FF5A4F] text-white rounded-[8px] px-6 py-3 text-sm font-medium hover:bg-[#e8463c] transition-colors";
const btnSecondary =
  "inline-flex items-center justify-center gap-2 border-2 border-white text-white rounded-[8px] px-6 py-3 text-sm font-medium hover:bg-white/10 transition-colors";

export function WorkWithMeHero() {
  return (
    <section
      data-testid="work-with-me-hero"
      className="relative w-full overflow-hidden"
      style={{ minHeight: "min(75vh, 658px)" }}
    >
      <img
        src={`${A}/blueprint4joy-work-hero-mountain-cabin.jpg`}
        alt="Intimate coaching conversation in a mountain cabin with panoramic windows."
        data-testid="work-hero-image"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ 
          objectPosition: "75% 45%",
          transform: "scale(1.18)",
          transformOrigin: "center center"
        }}
      />
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(to right, rgba(28,25,23,0.79) 0%, rgba(28,25,23,0.68) 32%, rgba(28,25,23,0.43) 56%, rgba(28,25,23,0.11) 78%, rgba(28,25,23,0) 92%)",
        }}
      />
      <div
        aria-hidden
        className="absolute inset-0 md:hidden"
        style={{ background: "rgba(28,25,23,0.52)" }}
      />
      <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 pt-20 md:pt-24 pb-16 md:pb-20 min-h-[inherit] flex items-center">
        <div className="max-w-[622px] reveal text-white">
          <h1
            data-testid="work-hero-headline"
            className="font-display text-[36px] sm:text-[53px] lg:text-[64px] leading-[1.03] tracking-tight text-white"
          >
            You don&rsquo;t need another plan.
          </h1>
          <p className="mt-2 font-display text-[28px] sm:text-[37px] lg:text-[43px] leading-[1.1] tracking-tight text-white/90">
            You need a way forward.
          </p>
          <div className="mt-8 space-y-4 text-lg md:text-xl leading-relaxed max-w-lg text-white/90">
            <p>
              You don&rsquo;t need to figure out the rest of your life today.
            </p>
            <p>You only need to know where to begin.</p>
          </div>
          <div className="mt-9 flex flex-col sm:flex-row sm:items-center gap-4">
            <a href={JOYSPOT_QUIZ_URL} data-testid="hero-cta-joyspot" className={btnPrimary}>
              Find Your JOYspot™
            </a>
            <a
              href="#offerings"
              data-testid="hero-cta-explore"
              className={btnSecondary}
            >
              Explore Ways to Work Together
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
